import { useCallback, useEffect, useState } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import AppGrid from "@/components/AppGrid";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { fetchStats } from "@/lib/api";

export default function HomePage() {
  const [stats, setStats] = useState(null);

  const refreshStats = useCallback(async () => {
    try {
      const data = await fetchStats();
      setStats(data);
    } catch {
      /* noop */
    }
  }, []);

  useEffect(() => {
    refreshStats();
  }, [refreshStats]);

  const handleAppsLoaded = useCallback(
    (apps) => {
      const total = apps.reduce((sum, a) => sum + (a.clicks || 0), 0);
      const cats = Array.from(new Set(apps.map((a) => a.category)));
      setStats({
        total_apps: apps.length,
        total_clicks: total,
        categories: cats,
      });
      refreshStats();
    },
    [refreshStats]
  );

  return (
    <div data-testid="home-page" className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Hero stats={stats} />
        <AppGrid onAppsLoaded={handleAppsLoaded} />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
